import { GenericServices } from './generic.services';
import Uri from '../common/uri/history-uri.constants'
import { ApiResponse } from '../models/app-configuration';
import { BaseHistoryParameter } from '../models/base-history-paramter';
import {IPayloadHistory} from "../models/history/history-model";
import {IPropertyHistoryProspectModel} from "../models/history/property-history-response.model";
import moment from 'moment';
export class HistoryServices extends GenericServices {

  getListOfHistory<T>(param: BaseHistoryParameter<T>, { id, childId }) {

    let path: string = Uri.default.replace(':id', param.Id.toString())
    if (childId) {
      path += '/' + childId
    }

    return super.executeSelectingPost(param, path)
      .then((response: ApiResponse) => {
        if (response.isSuccess) {
          if ((param.Mode === 'Relation' || param.Mode === 'PropertyProspect' ) && response.data && response.data.listOfItems)  {
            response.data.listOfItems.forEach(record => {
              record.children = null;
            });
          }
          return Promise.resolve(response.data)
        }
        return Promise.reject(response.message)
      })
      .catch(error => Promise.reject(error))
  }
  
  updateHistory(payload:IPayloadHistory, payloadOrigin: IPayloadHistory): Promise<any> {
      if (!payload || !payload.History || !payload.History.Id) return;
      payload.History.Date = moment(payload.History.Date).local().format();
    return super.executeUpdatingCompare(payloadOrigin, payload, Uri.updateHistoryById.replace(":id", payload.History.Id.toString()))
        .then((response: any) => {
            if(response.isSuccess === false) {
              return Promise.reject(response);
            }
            return response;
        })
  }
  
    setHistory(payload: IPayloadHistory) {
        payload.History.Date = moment(payload.History.Date).local().format();
    return super.executePost(payload, Uri.setHistory);
  }
  
  getHistoryById(payload: {Id: number}) {
    if (!payload || !payload.Id) return;
    return super.executeSelecting(undefined, Uri.getHistoryById.replace(':id', payload.Id.toString()), false);
  }

  editProspectProperty(payloadOrigin: IPropertyHistoryProspectModel, payload: IPropertyHistoryProspectModel): Promise<any> {
    let path: string = Uri.default.replace(':id', payload.ObjectId.toString()) + '/' + payload.PersonId.toString();

    return super.executeUpdatingCompare(payloadOrigin, payload, path)
      .then((response: any) => {
          if(response.isSuccess === false) {
            return Promise.reject(response);
          }
          return response;
      })
  }

    getEmailOutTemplate(historyId): Promise<any> {
        return super.executeSelecting(undefined, Uri.getEmailOut.replace(':id', historyId))
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                } else return Promise.reject(response.message);
            }).catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    forwardHistoryEmailOut(payload): Promise<any> {
        return super.executePost(payload, Uri.forwardEmailOut)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                } else return Promise.reject(response.message);
            }).catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    deleteHistory(payload): Promise<any> {
        return super.executeDeleting(Uri.deleteHistory.replace('{id}', payload.Id).replace('{hisDetailId}', payload.HisDetailId))
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                } else return Promise.reject(response.message);
            }).catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }
}